import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { baseColors } from '../../Themes/colors';
var HeaderWrapper = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 45,
    padding: '0 20px',
    backgroundColor: baseColors.fullWhite,
    borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
    flexShrink: 0,
    position: 'sticky',
    top: 0,
    zIndex: 5,
    '& .header-left': {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        minWidth: 0,
        paddingLeft: '2px',
        '& .header-icon': {
            display: 'flex',
            alignItems: 'center',
            '& span': { fontSize: 24 },
        },
        '& .back-btn': {
            marginLeft: -2,
        },
        '& .detail-title': {
            fontWeight: 700,
            fontSize: 17,
            lineHeight: '24px',
            color: '#1A1A1A',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '62vw',
        },
    },
    '& .header-center': {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        padding: '0 32px',
        maxWidth: 480,
        margin: '0 auto',
    },
    '& .header-search': {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: '100%',
        height: 30,
        border: "1px solid ".concat(baseColors.greyPreset[40]),
        borderRadius: 20,
        padding: '0 14px',
        backgroundColor: '#F7F7F7',
        '& svg': {
            fontSize: 16,
            color: baseColors.greyPreset[20],
            flexShrink: 0,
        },
        '& input': {
            flex: 1,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontSize: 13,
            color: baseColors.fullBlack,
            fontFamily: "'Nunito', sans-serif",
            '&::placeholder': {
                color: baseColors.greyPreset[20],
            },
        },
    },
    '& .header-right': {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        '& .MuiIconButton-root': {
            color: baseColors.greyPreset[10],
            '&:hover': {
                backgroundColor: "".concat(baseColors.greyPreset[40], "33"),
            },
        },
        '& svg': {
            fontSize: 24,
        }
    },
});
export default HeaderWrapper;
